<mat-tab-group dynamicHeight>
    <mat-tab label="Edit Information">
        <app-order-edit (orderUpdated)="handleOrderUpdated()"></app-order-edit> 
    </mat-tab>
    <mat-tab label="Order History"> 
        <app-order-events #orderEvents *ngIf="order && order.id" [orderId]=order.id></app-order-events> 
    </mat-tab>
</mat-tab-group>